/**
 * @flow
 * @relayHash 0ea181b5ee362e21a58eecb914a328c1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type RunControls_run$ref = any;
type RunDetails_run$ref = any;
type RunEndModal_run$ref = any;
type RunLog_run$ref = any;
type RunYields_run$ref = any;
type SetupEndModal_run$ref = any;
export type RunStatus = "COMPLETE" | "IN_PROGRESS" | "PAUSED" | "SCHEDULED";
export type UpdateRunStartInput = {|
  runId: string,
  userNumber: string,
  notes?: ?string,
|};
export type UpdateRunStartMutationVariables = {|
  input: UpdateRunStartInput
|};
export type UpdateRunStartMutationResponse = {|
  +updateRunStart: {|
    +runEdge: {|
      +cursor: string,
      +node: {|
        +id: string,
        +status: RunStatus,
        +scheduledStartAt: any,
        +scheduledEndAt: any,
        +$fragmentRefs: RunControls_run$ref & SetupEndModal_run$ref & RunEndModal_run$ref & RunDetails_run$ref & RunYields_run$ref & RunLog_run$ref,
      |},
    |}
  |}
|};
export type UpdateRunStartMutation = {|
  variables: UpdateRunStartMutationVariables,
  response: UpdateRunStartMutationResponse,
|};
*/


/*
mutation UpdateRunStartMutation(
  $input: UpdateRunStartInput!
) {
  updateRunStart(input: $input) {
    runEdge {
      cursor
      node {
        id
        status
        scheduledStartAt
        scheduledEndAt
        ...RunControls_run
        ...SetupEndModal_run
        ...RunEndModal_run
        ...RunDetails_run
        ...RunYields_run
        ...RunLog_run
      }
    }
  }
}

fragment RunControls_run on Run {
  id
  setupTotalSeconds
  runTotalSeconds
  status
  logs {
    id
    type
    notes
    createdAt
    user {
      id
      ...ProgressPanel_user
    }
  }
}

fragment SetupEndModal_run on Run {
  id
  jobState {
    id
    workflowState {
      id
      isTrackingSetupQuantity
    }
  }
  yields {
    edges {
      node {
        id
        quantity
        item {
          id
          name
          partNumber
          quantityUOM {
            id
            symbol
          }
        }
      }
    }
  }
  machine {
    id
    type {
      id
      name
    }
  }
}

fragment RunEndModal_run on Run {
  id
  jobState {
    id
    workflowState {
      id
      trackRunQuantityType
      isPromptingFinalQuantity
      defaultLot {
        id
      }
    }
  }
  yields {
    edges {
      node {
        id
        quantity
        item {
          id
          name
          partNumber
          lotTracking
          quantityUOM {
            id
            symbol
          }
        }
      }
    }
  }
  machine {
    id
    type {
      id
      name
    }
  }
}

fragment RunDetails_run on Run {
  id
  notes
  scheduledStartAt
  scheduledEndAt
  machine {
    id
    type {
      id
    }
  }
  jobState {
    id
  }
  job {
    id
    jobNumber
    importJobNumber
    name
    ...UpdateJobStateModal_job
    workflow {
      id
      states {
        id
        name
        isRequired
        type
      }
      transitions {
        id
        toWorkflowState {
          id
        }
        fromWorkflowState {
          id
        }
      }
    }
    states {
      id
      isEnabled
      status
      workflowState {
        id
        name
        type
        isAssignable
        machineType {
          id
        }
        form {
          id
        }
      }
      ...UpdateJobStateModal_jobState
      ...JobStateGrid_jobState
    }
    order {
      id
      customer {
        id
        name
      }
    }
  }
}

fragment RunYields_run on Run {
  id
  yields {
    edges {
      defectQuantity
      setupQuantity
      runQuantity
      node {
        id
        item {
          id
          name
          quantityUOM {
            id
            symbol
          }
        }
      }
    }
  }
}

fragment RunLog_run on Run {
  id
  machine {
    id
  }
  yields {
    edges {
      setupQuantity
      runQuantity
      defectQuantity
      node {
        id
        item {
          id
          name
          quantityUOM {
            id
            symbol
          }
        }
      }
    }
  }
  ...RunLogs_run
}

fragment RunLogs_run on Run {
  id
  yields {
    edges {
      setupQuantity
      runQuantity
      defectQuantity
      node {
        id
        item {
          id
          name
        }
      }
    }
  }
  machine {
    id
  }
  logs {
    id
    type
    notes
    createdAt
    user {
      ...UserWidget_user
      id
    }
  }
}

fragment UserWidget_user on User {
  id
  firstName
  lastName
  ...UserAvatar_user
}

fragment UserAvatar_user on User {
  id
  avatar
  firstName
}

fragment UpdateJobStateModal_job on Job {
  id
  status
  workflow {
    id
    states {
      id
      name
      isRequired
      type
    }
    transitions {
      id
      toWorkflowState {
        id
      }
      fromWorkflowState {
        id
      }
    }
  }
  states {
    id
    isEnabled
    status
    workflowState {
      id
      name
      type
    }
  }
}

fragment UpdateJobStateModal_jobState on JobState {
  id
  formFieldValues
  status
  workflowState {
    id
    name
    isAssignable
    type
    machineType {
      id
    }
    defaultUser {
      id
    }
    form {
      id
      name
      type
      systemKey
      productionType {
        id
      }
      fields {
        id
        systemKey
        type
        name
        description
        placeholder
        isRequired
        isCreatable
        applicationType
        displayOrder
        properties
        options {
          name
          value
          id
        }
        ...AdditionalFieldInfo_formField
      }
    }
  }
  user {
    id
  }
}

fragment JobStateGrid_jobState on JobState {
  id
  formFieldValues
  isEnabled
  status
  user {
    id
    ...UserWidget_user
  }
  workflowState {
    id
    name
    isAssignable
    type
    form {
      id
      fields {
        id
        name
        type
        ...CosmeticFieldValue_formField
        ...AdditionalFieldInfo_formField
      }
    }
  }
}

fragment CosmeticFieldValue_formField on FormField {
  id
  name
  type
}

fragment AdditionalFieldInfo_formField on FormField {
  id
  name
  type
}

fragment ProgressPanel_user on User {
  id
  firstName
  lastName
  avatar
  ...UserAvatar_user
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateRunStartInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scheduledStartAt",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scheduledEndAt",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "user",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lastName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "avatar",
      "args": null,
      "storageKey": null
    }
  ]
},
v10 = [
  (v3/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v12 = [
  (v3/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isRequired",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "systemKey",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateRunStartMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateRunStart",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRunStartPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "runEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "RunEdge",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Run",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "RunControls_run",
                    "args": null
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "SetupEndModal_run",
                    "args": null
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "RunEndModal_run",
                    "args": null
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "RunDetails_run",
                    "args": null
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "RunYields_run",
                    "args": null
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "RunLog_run",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateRunStartMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateRunStart",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRunStartPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "runEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "RunEdge",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Run",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "setupTotalSeconds",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "runTotalSeconds",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "logs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RunLog",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "jobState",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobState",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "workflowState",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isTrackingSetupQuantity",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "trackRunQuantityType",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isPromptingFinalQuantity",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "defaultLot",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Lot",
                            "plural": false,
                            "selections": (v10/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "yields",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RunYieldConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "RunYieldEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobYield",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "quantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "partNumber",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "quantityUOM",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UOM",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "symbol",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lotTracking",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "defectQuantity",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "setupQuantity",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "runQuantity",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "machine",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Machine",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "type",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MachineType",
                        "plural": false,
                        "selections": (v12/*: any*/)
                      }
                    ]
                  },
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "job",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Job",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "jobNumber",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "importJobNumber",
                        "args": null,
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "workflow",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Workflow",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "states",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/),
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "transitions",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowTransition",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "toWorkflowState",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "WorkflowState",
                                "plural": false,
                                "selections": (v10/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "fromWorkflowState",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "WorkflowState",
                                "plural": false,
                                "selections": (v10/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "states",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobState",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isEnabled",
                            "args": null,
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "workflowState",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v11/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isAssignable",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "machineType",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MachineType",
                                "plural": false,
                                "selections": (v10/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "form",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Form",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v11/*: any*/),
                                  (v7/*: any*/),
                                  (v14/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "productionType",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ProductionType",
                                    "plural": false,
                                    "selections": (v10/*: any*/)
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "fields",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FormField",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v14/*: any*/),
                                      (v7/*: any*/),
                                      (v11/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "description",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "placeholder",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v13/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isCreatable",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "applicationType",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "displayOrder",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "properties",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "options",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "FormFieldOption",
                                        "plural": true,
                                        "selections": [
                                          (v11/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "value",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          (v3/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "defaultUser",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "User",
                                "plural": false,
                                "selections": (v10/*: any*/)
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "formFieldValues",
                            "args": null,
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "order",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Order",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "customer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Customer",
                            "plural": false,
                            "selections": (v12/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateRunStartMutation",
    "id": null,
    "text": "mutation UpdateRunStartMutation(\n  $input: UpdateRunStartInput!\n) {\n  updateRunStart(input: $input) {\n    runEdge {\n      cursor\n      node {\n        id\n        status\n        scheduledStartAt\n        scheduledEndAt\n        ...RunControls_run\n        ...SetupEndModal_run\n        ...RunEndModal_run\n        ...RunDetails_run\n        ...RunYields_run\n        ...RunLog_run\n      }\n    }\n  }\n}\n\nfragment RunControls_run on Run {\n  id\n  setupTotalSeconds\n  runTotalSeconds\n  status\n  logs {\n    id\n    type\n    notes\n    createdAt\n    user {\n      id\n      ...ProgressPanel_user\n    }\n  }\n}\n\nfragment SetupEndModal_run on Run {\n  id\n  jobState {\n    id\n    workflowState {\n      id\n      isTrackingSetupQuantity\n    }\n  }\n  yields {\n    edges {\n      node {\n        id\n        quantity\n        item {\n          id\n          name\n          partNumber\n          quantityUOM {\n            id\n            symbol\n          }\n        }\n      }\n    }\n  }\n  machine {\n    id\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment RunEndModal_run on Run {\n  id\n  jobState {\n    id\n    workflowState {\n      id\n      trackRunQuantityType\n      isPromptingFinalQuantity\n      defaultLot {\n        id\n      }\n    }\n  }\n  yields {\n    edges {\n      node {\n        id\n        quantity\n        item {\n          id\n          name\n          partNumber\n          lotTracking\n          quantityUOM {\n            id\n            symbol\n          }\n        }\n      }\n    }\n  }\n  machine {\n    id\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment RunDetails_run on Run {\n  id\n  notes\n  scheduledStartAt\n  scheduledEndAt\n  machine {\n    id\n    type {\n      id\n    }\n  }\n  jobState {\n    id\n  }\n  job {\n    id\n    jobNumber\n    importJobNumber\n    name\n    ...UpdateJobStateModal_job\n    workflow {\n      id\n      states {\n        id\n        name\n        isRequired\n        type\n      }\n      transitions {\n        id\n        toWorkflowState {\n          id\n        }\n        fromWorkflowState {\n          id\n        }\n      }\n    }\n    states {\n      id\n      isEnabled\n      status\n      workflowState {\n        id\n        name\n        type\n        isAssignable\n        machineType {\n          id\n        }\n        form {\n          id\n        }\n      }\n      ...UpdateJobStateModal_jobState\n      ...JobStateGrid_jobState\n    }\n    order {\n      id\n      customer {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment RunYields_run on Run {\n  id\n  yields {\n    edges {\n      defectQuantity\n      setupQuantity\n      runQuantity\n      node {\n        id\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            symbol\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment RunLog_run on Run {\n  id\n  machine {\n    id\n  }\n  yields {\n    edges {\n      setupQuantity\n      runQuantity\n      defectQuantity\n      node {\n        id\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            symbol\n          }\n        }\n      }\n    }\n  }\n  ...RunLogs_run\n}\n\nfragment RunLogs_run on Run {\n  id\n  yields {\n    edges {\n      setupQuantity\n      runQuantity\n      defectQuantity\n      node {\n        id\n        item {\n          id\n          name\n        }\n      }\n    }\n  }\n  machine {\n    id\n  }\n  logs {\n    id\n    type\n    notes\n    createdAt\n    user {\n      ...UserWidget_user\n      id\n    }\n  }\n}\n\nfragment UserWidget_user on User {\n  id\n  firstName\n  lastName\n  ...UserAvatar_user\n}\n\nfragment UserAvatar_user on User {\n  id\n  avatar\n  firstName\n}\n\nfragment UpdateJobStateModal_job on Job {\n  id\n  status\n  workflow {\n    id\n    states {\n      id\n      name\n      isRequired\n      type\n    }\n    transitions {\n      id\n      toWorkflowState {\n        id\n      }\n      fromWorkflowState {\n        id\n      }\n    }\n  }\n  states {\n    id\n    isEnabled\n    status\n    workflowState {\n      id\n      name\n      type\n    }\n  }\n}\n\nfragment UpdateJobStateModal_jobState on JobState {\n  id\n  formFieldValues\n  status\n  workflowState {\n    id\n    name\n    isAssignable\n    type\n    machineType {\n      id\n    }\n    defaultUser {\n      id\n    }\n    form {\n      id\n      name\n      type\n      systemKey\n      productionType {\n        id\n      }\n      fields {\n        id\n        systemKey\n        type\n        name\n        description\n        placeholder\n        isRequired\n        isCreatable\n        applicationType\n        displayOrder\n        properties\n        options {\n          name\n          value\n          id\n        }\n        ...AdditionalFieldInfo_formField\n      }\n    }\n  }\n  user {\n    id\n  }\n}\n\nfragment JobStateGrid_jobState on JobState {\n  id\n  formFieldValues\n  isEnabled\n  status\n  user {\n    id\n    ...UserWidget_user\n  }\n  workflowState {\n    id\n    name\n    isAssignable\n    type\n    form {\n      id\n      fields {\n        id\n        name\n        type\n        ...CosmeticFieldValue_formField\n        ...AdditionalFieldInfo_formField\n      }\n    }\n  }\n}\n\nfragment CosmeticFieldValue_formField on FormField {\n  id\n  name\n  type\n}\n\nfragment AdditionalFieldInfo_formField on FormField {\n  id\n  name\n  type\n}\n\nfragment ProgressPanel_user on User {\n  id\n  firstName\n  lastName\n  avatar\n  ...UserAvatar_user\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2cdc8bac9fc168abeec18d737d51ac8e';
module.exports = node;
